import { Modal } from 'react-bootstrap';

import Button from '../../generic/Button/Button';
import ButtonGroup from '../../generic/Button/ButtonGroup';
import Icon, { icons } from '../../generic/Icon';

type ModalRequestOrgAccessProps = {
  orgTitle: string;
  isShown: boolean;
  onHide: () => void;
  onRequestAccess: () => void;
};

/**
 * Modal which is displayed when users are attempting to create an org
 * which already exists. This allows them to request access to join this org instead.
 *
 * @param {string} orgTitle - Name of the org trying to join.
 * @param {boolean} isShown - If the modal is currently displayed or not.
 * @param {() => void} onHide - Method which will close the modal.
 * @param {() => void} onRequestAccess - Method called when the user clicks "Request Access"
 */
const ModalRequestOrgAccess = ({
  orgTitle,
  isShown,
  onHide,
  onRequestAccess,
}: ModalRequestOrgAccessProps) => (
  <Modal show={isShown} onHide={onHide} className="modal">
    <Modal.Header closeButton>
      <Modal.Title>
        Join Organization {orgTitle}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <span className="pull-left margin-right-sm margin-left-sm margin-top-lg margin-bottom-lg" style={{ fontSize: 80 }}>
        <Icon icon={icons.building} />
      </span>
      <h1>
        <b>{orgTitle}</b> is taken
      </h1>
      <p>
        Your team may have already set up FOSSA. Send a request to join the existing organization, or create a new separate one.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <ButtonGroup>
        <Button
          type="secondary"
          onClick={onHide}
        >
          Create a new Organization
        </Button>
        <Button
          type="primary"
          onClick={onRequestAccess}
        >
          Request Access
        </Button>
      </ButtonGroup>
    </Modal.Footer>
  </Modal>
);

export default ModalRequestOrgAccess;
